import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    HostBinding,
    Input,
    OnChanges,
    Renderer2,
    SimpleChanges,
    Output,
    EventEmitter,
    OnInit
} from "@angular/core";
import { SpsIcon, MultiSelectTagKind } from "@spscommerce/ds-shared";

@Component({
    selector: "sps-multi-select-tag",
    template: `
        <ng-content></ng-content><i *ngIf="icon" class="sps-icon sps-icon-{{icon}}" (click)="emitEvent()"></i>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpsMultiSelectTagComponent implements OnChanges, OnInit {
    static readonly displayName = "sps-multi-select-tag";
    static readonly props = {
        kind: "MultiSelectTagKind",
        add: { event: true, type: "void" },
        remove: { event: true, type: "void" },
    };

    @Input() kind: MultiSelectTagKind = MultiSelectTagKind.BLUE;
    icon: SpsIcon;

    @Output() remove = new EventEmitter<void>();
    @Output() add = new EventEmitter<void>();

    @HostBinding("class.sps-multi-select-tag") readonly _spsMultiSelectTagClass = true;

    constructor(private _elementRef: ElementRef, private _renderer: Renderer2) {}

    emitEvent() {
        if (this.icon === SpsIcon.X) { this.remove.emit(); }
        if (this.icon === SpsIcon.PLUS_SIGN) { this.add.emit(); }
    }

    ngOnInit() {
        this.icon = this.kind === MultiSelectTagKind.GRAY ? SpsIcon.PLUS_SIGN : SpsIcon.X;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.kind) {
            this._renderer.removeClass(
                this._elementRef.nativeElement,
                `sps-multi-select-tag--${changes.kind.previousValue}`
            );
            this._renderer.addClass(
                this._elementRef.nativeElement,
                `sps-multi-select-tag--${changes.kind.currentValue}`
            );
        }
    }
}
